import React from "react";
import { Link } from "gatsby";
import Image from "@herb/components/Image";
import RedirectLink from "@herb/components/RedirectLink";
import productLink from "@herb/utils/productLink";
import Button from "@herb/components/Button";
import { track, trackTransferToShop, trackSelectItem } from "@herb/utils/analytics";
import { getOutboundLinkRel } from "@herb/utils";
import "./index.css";
import { fallbackImages } from "../../../utils/constants";

const ProductHit = hit => {
  const { acf, contentProducts } = hit;
  const image = acf ? acf.product_images[0] : contentProducts?.productThumbnail;

  const { productCategory: category, affiliateUrl, brand } = contentProducts;
  const brandName = brand?.title || hit?.brand_name || "";
  return (
    <div
      className="mSingleProduct"
      css={{
        width: "32%",
        "@media screen and (max-width:768px)": {
          width: "48%"
        }
      }}
    >
      <Link 
        to={`/products/${category?.slug}/${brand?.slug}-${hit?.slug}`}
        onClick={() => {
          trackSelectItem({
            itemName: hit?.title,
            itemCategory: category?.name || '',
            surfaceType: 'search_results',
            brand: brandName
          });
        }}
      >
        <div className="mProductImg">
          <Image
            className="lazyload mImg"
            sizes="(min-width: 40em) 30vw, 40vw"
            src={image?.source_url}
            alt={image?.alt_text}
            fallback={fallbackImages.square}
            height={217}
            width={192}
            imgixParams={{
              ar: "4:3",
              crop: "focalpoint",
              fit: "crop"
            }}
            attributeConfig={{
              src: "data-src",
              srcSet: "data-srcset",
              sizes: "data-sizes"
            }}
          />
        </div>
        <div className="mProductDetails">
          <p className="mCategory">{(category || {}).name}</p>
          <h4 className="mTitle">{hit?.title}</h4>
        </div>
      </Link>
      <div className="buyHitProduct">
        <Button
          href={affiliateUrl}
          target="_blank"
          link
          analytics={() => {
            trackTransferToShop({
              affiliateUrl,
              contentType: 'search_page',
              surfaceType: 'search_results',
              productTitle: hit?.title,
              category: category?.name || '',
              brand: brandName
            });
          }}
          rel={getOutboundLinkRel({ brand: brandName })}
          stlyes={{
            fontStyle: "italic",
            padding: "6px 18px",
            fontSize: "20px",
            lineHeight: "24px"
          }}
          type="boutiqueButton"
        >
          shop now
        </Button>
      </div>
      <Link 
        className="viewProductHitCard" 
        to={productLink(hit)}
        onClick={() => {
          trackSelectItem({
            itemName: hit?.title,
            itemCategory: category?.name || '',
            surfaceType: 'search_results',
            brand: brandName
          });
        }}
      >
        View Product
      </Link>
    </div>
  );
};

export default ProductHit;
